// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"d4f3b765","276":"d4f3b765","643":"9a918271","660":"d4f3b765","738":"85fc9e4c","923":"d4f3b765"}[chunkId] + ".chunk.css";
};